import {
	AudienceModalComponent,
	type AudienceModalSection,
	useAudience,
	useCreateAudienceEffect,
} from "@di-devs/audience-feature-plugin/client";
import {
	MemberAttributeAudienceFilters,
	MemberAudienceFilters,
} from "@di-devs/member-feature-plugin/client";
import { useBetterFeatureClient } from "@di-devs/utils-fe";
import type { FC } from "react";
import type { FeatureClient } from "@/config/client";
import { useListMemberAttributes } from "@/queries/memberAttributes.queries";

interface MemberAudienceModalProps {
	visible: boolean;
	onClose: () => void;
}

const MemberAudienceModal: FC<MemberAudienceModalProps> = ({
	visible,
	onClose,
}) => {
	const client = useBetterFeatureClient<FeatureClient>();
	const {
		hooks: { createAudienceMutation, searchAudienceMutation },
	} = useAudience();

	// Fetch member attributes for the filter component
	const { data: memberAttributesResponse } = useListMemberAttributes(client, {
		enabled: visible,
	});

	// TODO: This should be feature flagged
	const adminFilteredMemberAttributes =
		(memberAttributesResponse as any)?.data?.data?.filter(
			(item: any) => item?.isAdminDisplayed,
		);

	const memberAttributes = adminFilteredMemberAttributes || [];

	// Define filter sections for the composer
	const filterSections: AudienceModalSection[] = [
		{
			key: "memberFilters",
			title: "メンバーフィルター",
			content: <MemberAudienceFilters />,
		},
		{
			key: "attributeFilters",
			title: "属性フィルター",
			content: (
				<MemberAttributeAudienceFilters memberAttributes={memberAttributes} />
			),
		},
	];

	// MARK: UI Effects
	useCreateAudienceEffect(createAudienceMutation, {
		onSuccess: onClose,
		onError: (error) => {
			console.error("Failed to create audience:", error);
		},
	});

	return (
		<AudienceModalComponent.Provider visible={visible} onClose={onClose}>
			<AudienceModalComponent.Composer sections={filterSections} />
			<AudienceModalComponent.Container
				width={{
					create: 520,
				}}
			>
				<AudienceModalComponent.Body>
					<AudienceModalComponent.Header />
					<AudienceModalComponent.Filters
						onFinish={(values) =>
							searchAudienceMutation.mutate({ ...values, type: "member" })
						}
					/>
					<AudienceModalComponent.Results
						count={searchAudienceMutation.data?.count || 0}
					/>
					<AudienceModalComponent.Actions
						onCreate={(values) =>
							createAudienceMutation.mutate({ ...values, type: "member" })
						}
						isLoading={createAudienceMutation.isPending}
						searchResults={searchAudienceMutation.data}
					/>
				</AudienceModalComponent.Body>
			</AudienceModalComponent.Container>
		</AudienceModalComponent.Provider>
	);
};

export default MemberAudienceModal;
